import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { EnvService } from 'src/app/core/services';
import { asFormControl } from 'src/app/core/utils/common';
import { notCcsmedEmail } from 'src/app/core/utils/validators';

@Component({
  selector: 'app-forgot-form',
  templateUrl: './forgot-form.component.html',
  styleUrls: ['./forgot-form.component.scss'],
})
export class ForgotFormComponent implements OnInit {
  @Input() username!: string;
  @Input() onSignIn!: () => void;
  @Input() onSuccessfulReset!: () => void;
  @Input() updateUsername!: (username: string) => void;

  forgotForm = new FormGroup({
    username: new FormControl('', [Validators.required, Validators.email, notCcsmedEmail()]),
  });
  disableButton: boolean = true;
  errorMessage: string = '';
  recaptcha: { render: any } | null = null;
  captchaSiteKey = this.envService.captcha.siteKey;

  asFormControl = asFormControl;

  constructor(@Inject(OKTA_AUTH) private oktaAuth: OktaAuth, private envService: EnvService) {}

  ngOnInit(): void {
    this.forgotForm.patchValue({ username: this.username });
    this.recaptcha = (window as any).grecaptcha;

    const captchaContainer = document.getElementById('captcha-container');

    this.recaptcha?.render(captchaContainer, {
      sitekey: this.captchaSiteKey,
      callback: () => {
        this.disableButton = false;
      },
      'expired-callback': () => {
        this.disableButton = true;
      },
    });

    this.forgotForm.valueChanges.subscribe((value) => {
      this.updateUsername(value.username);
    });
  }

  onSubmit(): void {
    if (this.forgotForm.invalid) {
      this.forgotForm.markAllAsTouched();
      return;
    }

    this.disableButton = true;
    this.errorMessage = '';

    this.oktaAuth
      .forgotPassword({
        factorType: 'EMAIL',
        username: this.forgotForm.value.username,
      })
      .then(() => {
        this.onSuccessfulReset();
      })
      .catch((err) => {
        this.errorMessage = err.message;
        this.disableButton = false;
      });
  }
}
